<template>
  <div>
    <v-row no-gutters>
      <v-col class="fill-width pt-0 pb-3">
        <v-row>
          <v-col
            :class="option.class ? option.class : 'px-5'"
            v-for="(option) in options"
            v-bind:key="option.key"
            :cols="option.cols ? option.cols : false"
            :sm="option.sm ? option.sm : false"
            :md="option.md ? option.md : false"
            :lg="option.lg ? option.lg : false"
            :xl="option.xl ? option.xl : false"
          >
            <Field :option="option" />
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="false" cols="12" md="12" class="d-flex justify-center d-print-none">
        <v-btn 
          small
          class="ma-auto"
          text 
          block 
          @click="toggleAdvancedOptions">
            <span class="font-weight-bold blue--text">More Filters</span> <v-icon x-small class="blue--text">{{ advancedChevron }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    
    <v-row v-if="showAdvancedOptions">
      <v-spacer />
      <v-col
        :class="option.class ? option.class : 'px-5'"
        v-for="(option) in advanced"
        v-bind:key="option.key"
        :cols="option.cols"
        :sm="option.sm ? option.sm : false"
        :md="option.md ? option.md : false"
      >
        <Field :option="option" />
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-col
        class="py-0 px-0"
        v-for="(option) in bars"
        v-bind:key="option.key"
        :cols="option.cols"
        :sm="option.sm ? option.sm : false"
      >
        <Field :option="option" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Field from "./Field";
import Ad from "./Ad";

export default {
  name: "Options",
  components: {
    Field,
    Ad
  },
  data() {
    return {
      showAdvancedOptions: false
    };
  },
  computed: {
    options() {
      return this.$store.getters.getCurrentOptions;
    },
    advanced() {
      return this.$store.getters.getCurrentAdvanced;
    },
    bars() {
      return this.$store.getters.getCurrentBars;
    },
    buttonText() {
      return this.showAdvancedOptions ? "Less" : "More";
    },
    advancedChevron() {
      return this.showAdvancedOptions ? 'mdi-minus' : 'mdi-plus';
    }
  },
  methods: {
    toggleAdvancedOptions() {
      this.showAdvancedOptions = !this.showAdvancedOptions;
    }
  }
};
</script>

<style scoped>
.text-underline {
  text-decoration: underline;
}
</style>